import React from "react";

const SpecialistRecommendations = ({ diseases, knowledgeBase }) => {
    if (!diseases || diseases.length === 0) return null;

    // Obtener especialistas únicos
    const specialistSet = new Set();

    diseases.forEach((diseaseName) => {
        const match = knowledgeBase.find((d) => d.disease === diseaseName);
        if (match?.specialists) {
            match.specialists.forEach((spec) => specialistSet.add(spec));
        }
    });

    const specialists = Array.from(specialistSet);

    return (
        <div style={{ marginTop: "30px" }}>
            <h2>Especialistas recomendados</h2>
            {specialists.length === 0 ? (
                <p>No se pudo determinar un especialista.</p>
            ) : (
                <ul style={{ paddingLeft: "20px", color: "#333" }}>
                    {specialists.map((s, i) => (
                        <li key={i} style={{ marginBottom: "8px", fontWeight: "500" }}>
                            {s}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SpecialistRecommendations;
